import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/component/header";
import Footer from "@/component/footer";
import ListsGrid from "@/component/commom/lists-grid";
import { userRepo } from "@/repo/user-repo";
import { PublicListData } from "@/entry/server/user";
import { Pagination } from "@/lib/api";
import { useQueryParams, getQueryParam } from "@/hooks/useQueryParams";
import NotFound from "@/pages-app/not-found";

export default function Page() {
    const queryParams = useQueryParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [lists, setLists] = useState<PublicListData[]>([]);
    const [pagination, setPagination] = useState<Pagination | null>(null);

    useEffect(function () {
        setLoading(true);
        setNotFound(false);
        var page = getQueryParam(queryParams, "page", "1");
        userRepo.getPublicLists(Number(page)).then(function (listsResponse) {
            if (!listsResponse.status) {
                setNotFound(true);
                setLoading(false);
                return;
            }
            if (listsResponse.data) {
                setLists(listsResponse.data);
            }
            if (listsResponse.pagination) {
                setPagination(listsResponse.pagination);
            }
            setLoading(false);
        });
    }, [location.search]);

    if (notFound) {
        return <NotFound />;
    }

    if (loading || !pagination) {
        return (
            <div className="page-loading">
                <div className="loader" />
            </div>
        );
    }

    return (
        <>
            <Header />
            <ListsGrid defaultLists={lists} defaultPagination={pagination} />
            <Footer />
        </>
    );
}
